import "./JobBoard.module.css";
import MainNavigation from "@/reusable_sections/Header";
import OpenPositions from "./sections/OpenPositions";
import StayInformed from "./sections/StayInformed";
import CorporateFooter from "@/reusable_sections/Footer";
export default function JobBoardPage() {
  return <div>
      <MainNavigation />
      <OpenPositions />
      <StayInformed />
      <CorporateFooter />
    </div>;
}